import { gql } from '@apollo/client';
const CLEAN_DATA = gql `
  mutation CleanData($runSeed: Boolean!) {
    cleanData(runSeed: $runSeed)
  }
`;
export default CLEAN_DATA;
